import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const useStyles = makeStyles(() => {
    return createStyles({
        icon: {
            fontSize: 16,
            display: 'block',
            marginLeft: 0,
        },
        deleted: {
            color: palette.error.main,
        },
        disabled: {
            color: palette.text.secondary,
        },
        enabled: {
            color: palette.success.main,
        },
        unknown: {
            color: palette.primary.light,
        },
    })
})
